export const DEFAULT_BASE_CURRENCY = "GBP";
